import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { PublishStatusEnum } from "../enums/publishStatus.enum";
import { IsNotEmpty } from "@pineapplelab/validators";
import { Language } from "../utils/language";

export class Course extends FBase {

    totalMinutes: number = 0;
	@IsNotEmpty({ label: "Name" })
	name: string = null;
	@IsNotEmpty({ label: "Description" })
	description: string = null;
	image: string = null;
	totalChapters: number = 0;
	languages: Language[] = [];
	status: PublishStatusEnum = null;
	index: number = null;
	creationDate: string = null;
	assigned: boolean = false;
	nameLowercase: string = null;
	guidedMode: boolean = true;
	requirePassToContinue: boolean = true;
	readyToPublish: boolean = false;
	createdByAdmin: boolean = false;
	inPersonMode: boolean = false;
	/** Id of the course this one was duplicated from, if any. */
	duplicatedFrom: string = null;
	/**
	 * Set on duplicates: the translations were copied from the source course and won't reflect
	 * chapter changes until they're regenerated. Cleared by "Regenerate all" in the course form.
	 */
	translationsInherited: boolean = false;

	author: string = null;
	price: number = null;
	duration: number = null;

	__fileImage: File;
	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace Course {
	export const PATH = 'courses';
	export const COUNTERCOLLECTION= 'counters';
	export const COUNTER= 'courseCounter';
	export const COUNTERSTART= 100000;
}
